import React from 'react';
import { connect } from 'react-redux';
import ClozePassageIncorrectFeedback from './clozePassage.incorrect';
import ClozePassageCorrectFeedback from './clozePassage.correct';

import SpeechCorrect from '../saFeedback/speechCorrect';
import SpeechIncorrect from '../saFeedback/speechIncorrect';

import SpeedDetailedFeedback from '../saFeedback/speechDetailedFeedback';
import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';
const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const WordCloudFeedback = ({
	rightFeedbackProps: { score, defaultFeedback },
	leftFeedbackProps: { qdomain },
}) => {
	return (
		<section className="quiz-area-options">
			{score >= 0.4 ? (
				<ClozePassageCorrectFeedback />
			) : (
				<ClozePassageIncorrectFeedback />
			)}
			{qdomain === 'S' && (score === 1 ? <SpeechCorrect /> : <SpeechIncorrect />)}

			{!!defaultFeedback && Object.keys(defaultFeedback).includes('accuracy') && (
				<SpeedDetailedFeedback />
			)}

			{!!defaultFeedback && (
				<div class="tutor-feedback">
					<i class="fa fa-comments-o" aria-hidden="true"></i>
					<p>
						<span>Feedback</span>
						{defaultFeedback}
					</p>
				</div>
			)}

			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(WordCloudFeedback);
